"use client";

import dynamic from "next/dynamic";

// Capture only runs for authorized sessions and needs the full app store, so
// it loads after hydration instead of riding in every page's first-paint JS.
const UserSessionLogCapture = dynamic(() => import("./UserSessionLogCapture"), { ssr: false });

export default function UserSessionLogProvider() {
  return <UserSessionLogCapture />;
}
